import styled from 'styled-components'

export const Container = styled.div`
  display: inline-block;
  position: relative;

  .calendarElement {
    position: absolute;
    /* transform: translateX(-50%); */
    top: 65px;
    border: 1px solid #ccc;
    z-index: 999;
  }

  .rdrDefinedRangesWrapper {
    display: none;
  }
`
